import { createSelector } from 'reselect';
import { flatten } from 'lodash/fp';

import playerPositionsSelector from './playerPositionsSelector';
import teamPositionsSelector from './teamPositionsSelector';
// import { assessLimits } from '../utils/positionUtils';

export const entityPositionsSelector = createSelector(
  playerPositionsSelector,
  teamPositionsSelector,
  (...args) => flatten(args)
);

// const quotaSelector = createSelector(
//   get('challenge.playerQuota'),
//   get('challenge.teamQuota'),
//   (...args) => sum(args)
// );

// const positionsSelector = createSelector(
//   entityPositionsSelector,
//   quotaSelector,
//   assessLimits
// );

export default entityPositionsSelector;
